import React from 'react';
import PropTypes from 'prop-types';

import {
  ExtendedBox,
  ExtendedFlex,
  Heading,
  Link,
  Body,
} from '../../coreui';

import BrowseLink from '../../components/BrowseLink';

class FundProperty extends React.Component {
  // eslint-disable-next-line
  showZendesk() {
    if (typeof zE !== 'undefined') {
      // eslint-disable-next-line
      zE.activate();
    }
  }

  render() {
    const {
      isLoggedIn,
      ...additionalProps
    } = this.props;

    return (
      <ExtendedFlex
        w={1}
        align="center"
        justify="center"
        flexDirection="column"
        py="10%"
        {...additionalProps}
      >
        <Heading
          type="H2"
          color="black"
          textAlign="center"
          m={0}
        >
          FUND YOUR NEXT 1031 PROPERTY
        </Heading>
        <ExtendedBox>
          <BrowseLink
            anonText="Get Started"
            isLoggedIn={isLoggedIn}
          />
        </ExtendedBox>
        <Body
          type="B1"
          m={0}
          pt={20}
        >
          OUR 1031 SPECIALISTS ARE HERE TO HELP
        </Body>
        <Heading
          mt={10}
          type="H6"
        >
          Call (877) 781-7062
        </Heading>
        <Link
          type="L4"
          mt={20}
          display="block"
          onClick={this.showZendesk}
        >
          Contact Investor Relations
        </Link>
      </ExtendedFlex>
    );
  }
}

FundProperty.propTypes = {
  isLoggedIn: PropTypes.bool,
};

export default FundProperty;
